__turbopack_context__.v({
  "button": "styles-module-scss-module__3tSIVG__button",
  "error": "styles-module-scss-module__3tSIVG__error",
  "formMessage": "styles-module-scss-module__3tSIVG__formMessage",
  "helperText": "styles-module-scss-module__3tSIVG__helperText",
  "icon": "styles-module-scss-module__3tSIVG__icon",
  "input": "styles-module-scss-module__3tSIVG__input",
  "inputWrapper": "styles-module-scss-module__3tSIVG__inputWrapper",
  "is-invalid": "styles-module-scss-module__3tSIVG__is-invalid",
  "label": "styles-module-scss-module__3tSIVG__label",
  "newsletter": "styles-module-scss-module__3tSIVG__newsletter",
  "redMode": "styles-module-scss-module__3tSIVG__redMode",
});
